import { useState } from 'react';
import {
  getHasOverviewChanged,
  getOverviewChanges,
  getValidationErrorMessages,
} from './utils';
import { HOURS, OVERVIEW } from './constants';

export const useOverview = ({ overview, updateProperty }) => {
  const [overviewTabData, setOverviewTabData] = useState(overview);
  const [validationErrorMessages, setValidationErrorMessages] = useState({});

  const handleOnUndo = () => {
    setOverviewTabData(overview);
  };

  const hasValidationErrors = () =>
    Object.values(validationErrorMessages).some(Boolean);

  const getIsActionsDisabled = () => {
    const hasOverviewChanged = getHasOverviewChanged(overview, overviewTabData);
    return !hasOverviewChanged || hasValidationErrors();
  };

  const updateOverviewSection = (tabViewSection) => (updates) => {
    setOverviewTabData((prevState) => ({
      ...prevState,
      [tabViewSection]: {
        ...prevState[tabViewSection],
        ...updates,
      },
    }));
  };

  const updateHours = (tab, day, updates) => {
    setOverviewTabData((prevState) => {
      const prevHours = prevState[HOURS] || {};
      const prevTab = prevHours[tab] || {};
      const prevDay = prevTab[day] || {};
      return {
        ...prevState,
        [HOURS]: {
          ...prevHours,
          [tab]: {
            ...prevTab,
            [day]: { ...prevDay, ...updates },
          },
        },
      };
    });
  };

  const onAddHolidayHours = () => {};

  const clearFieldErrorMessage = (field) => {
    setValidationErrorMessages((prevState) => ({
      ...prevState,
      [field]: '',
    }));
  };

  const validate = () => {
    const messages = getValidationErrorMessages(overviewTabData);

    if (messages) {
      setValidationErrorMessages(messages);
    }

    return !messages;
  };

  const handleOnSave = async () => {
    const isValid = validate();

    if (!isValid) {
      return;
    }

    const overviewUpdates = getOverviewChanges(overview, overviewTabData);
    const tabData = { [OVERVIEW]: overviewTabData };

    updateProperty(overviewUpdates, tabData);
  };

  return {
    clearFieldErrorMessage,
    handleOnSave,
    handleOnUndo,
    isActionsDisabled: getIsActionsDisabled(),
    onAddHolidayHours,
    overviewTabData,
    updateHours,
    updateOverviewSection,
    validationErrorMessages,
  };
};
